const SpotOnSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.48" height="29.004">
      <g data-name="グループ 12" strokeMiterlimit="10">
        <g data-name="パス 52" className="main-fill">
          <path d="M10.261 28.254c-.548 0-1.043-.26-1.357-.712-1.451-2.09-3.538-5.264-5.235-8.517-1.96-3.755-2.941-6.708-2.92-8.777a9.612 9.612 0 012.805-6.72A9.374 9.374 0 0110.24.75c5.233 0 9.49 4.257 9.49 9.49 0 2.206-.985 5.214-2.929 8.94-1.687 3.235-3.755 6.34-5.194 8.375a1.63 1.63 0 01-1.346.699z" />
          <path
            d="M10.24 1.5a8.629 8.629 0 00-6.155 2.558A8.865 8.865 0 001.5 10.256c-.036 3.322 2.887 9.467 8.02 16.858.244.352.6.39.741.39.174 0 .5-.05.734-.382 5.075-7.18 7.985-13.334 7.985-16.882 0-4.82-3.92-8.74-8.74-8.74m0-1.5c5.655 0 10.24 4.585 10.24 10.24 0 5.314-5.284 13.537-8.26 17.748a2.399 2.399 0 01-3.932-.018C5.302 23.67-.054 15.252 0 10.24.061 4.585 4.585 0 10.24 0z"
            fill="#000"
          />
        </g>
        <g data-name="楕円形 62" transform="translate(5.189 5.263)" fill="#fff" stroke="#000" strokeWidth="1.5">
          <circle cx="5.051" cy="5.051" r="5.051" stroke="none" />
          <circle cx="5.051" cy="5.051" r="4.301" fill="none" />
        </g>
      </g>
    </svg>
  )
}

export default SpotOnSvg
